import { openaiUsage } from "../openai/usage";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fireworksAi = defineConnector({
  identifier: "fireworksAi",
  name: "Fireworks AI",
  tagLine: "Fast inference for open AI models",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.fireworks\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [API keys](https://app.fireworks.ai/settings/users/api-keys) in your Fireworks AI account settings and create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: "fw_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fireworks.ai/inference/v1/models",
  },
  usage: openaiUsage(),
});
